(()=>{
  const init=(root)=>{
    if(!root||root.dataset.xwReady==='true')return;
    root.dataset.xwReady='true';
    const stage=root.querySelector('[data-xw-stage]');
    const replay=root.querySelector('[data-xw-replay]');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let settleTimer;
    const settle=()=>{window.clearTimeout(settleTimer);if(reduced){root.classList.add('is-settled');return}settleTimer=window.setTimeout(()=>root.classList.add('is-settled'),19000)};
    const restart=()=>{root.classList.remove('is-settled');root.classList.add('is-restarting');void root.offsetWidth;root.classList.remove('is-restarting');settle()};
    const updateScroll=()=>{
      if(!stage)return;
      const top=root.getBoundingClientRect().top+window.scrollY;
      const progress=Math.min(Math.max((window.scrollY-top)/(window.innerHeight*.72),0),1);
      stage.style.opacity=String(1-progress*.92);
      stage.style.filter=`blur(${progress*16}px)`;
      stage.style.transform=`translate3d(0,${progress*-28}px,0) scale(${1+progress*.035})`;
    };
    replay?.addEventListener('click',restart);
    window.addEventListener('scroll',updateScroll,{passive:true});
    updateScroll();
    settle();
  };
  const initAll=(scope=document)=>scope.querySelectorAll('[data-xw-motion]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll());else initAll();
  document.addEventListener('shopify:section:load',(event)=>initAll(event.target));
})();
